// extracted by mini-css-extract-plugin
export var label = "_hu-2";
export var slideContainer = "_hu-0";
export var slider = "_hu-1";